import { defineMessage } from 'services/localization';

export const messages = {
    tax: defineMessage('tax_3'),
    taxId: defineMessage('tax_id_number'),
    defaultSalesTax: defineMessage('default_sales_tax'),
    defaultPurchaseTax: defineMessage('default_purchase_tax'),
    companyNumber: defineMessage('company_registration_number'),
};
